import ReactPixel from 'react-facebook-pixel';

const pushGTM = (event: string, data?: Record<string, unknown>) => {
  (window as any).dataLayer?.push({ event, ...data });
};

export const trackLifetimePageView = () => {
  ReactPixel.track('ViewContent', {
    content_name: 'Lifetime Plan',
    content_category: 'Pricing',
  });
  pushGTM('lifetime_page_view');
};

export const trackLifetimeCheckoutClick = (planName: string, value: number) => {
  ReactPixel.track('InitiateCheckout', {
    content_name: planName,
    value,
    currency: 'PKR',
  });
  pushGTM('lifetime_initiate_checkout', { plan_name: planName, value });
};

export const trackLifetimePurchase = (value?: number) => {
  ReactPixel.track('Purchase', {
    content_name: 'Lifetime Plan',
    value: value ?? 0,
    currency: 'PKR',
  });
  pushGTM('lifetime_purchase', { value });
};

export const trackLifetimeCheckoutAbandoned = () => {
  ReactPixel.trackCustom('LifetimeCheckoutAbandoned', {});
  pushGTM('lifetime_checkout_abandoned');
};
